export default __webpack_public_path__ + "static/media/1.33490dc1.PNG";